import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const authField = "mt-1.5 h-12 w-full rounded-xl border border-[#E5E0D8] bg-white px-4 outline-none focus:border-[#C59B27] focus:ring-4 focus:ring-[#C59B27]/15";

export const AuthCard = ({ title, subtitle, onSubmit, children, testId }) => (
  <div className="grid min-h-screen place-items-center bg-[#FDFBF7] px-4" data-testid={testId}>
    <form onSubmit={onSubmit} className="w-full max-w-sm rounded-3xl border border-[#E5E0D8] bg-white p-7 shadow-[0_30px_60px_-40px_rgba(27,67,50,.5)]">
      <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#1B4332] text-[#F3DB8C]"><Lock className="h-5 w-5" /></span>
      <h1 className="mt-5 font-display text-3xl font-bold text-[#1B4332]">{title}</h1>
      <p className="mt-1 text-sm text-[#5B625D]">{subtitle}</p>
      {children}
      <Link to="/admin/login" className="mt-5 block text-center text-sm text-[#5B625D] hover:text-[#1B4332]" data-testid="auth-back-to-login">← Back to sign in</Link>
    </form>
  </div>
);

export const FormError = ({ error, testId }) => (error ? <p className="mt-4 rounded-lg bg-[#F6E4E1] px-3 py-2 text-sm text-[#8A2B1E]" role="alert" data-testid={testId}>{error}</p> : null);

export const SubmitButton = ({ busy, label, busyLabel, testId }) => (
  <button disabled={busy} className="mt-6 h-12 w-full rounded-full bg-[#1B4332] font-semibold text-white transition-colors hover:bg-[#10291F] disabled:opacity-60" data-testid={testId}>{busy ? busyLabel : label}</button>
);
